import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_nav_bar = _resolveComponent("van-nav-bar");

  return _openBlock(), _createBlock(_component_van_nav_bar, {
    title: $props.title,
    fixed: "",
    "safe-area-inset-top": "",
    placeholder: "",
    "left-text": $props.canReturn ? _ctx.$t('common.back') : undefined,
    "left-arrow": $props.canReturn,
    onClick: $options.click,
    onClickLeft: $options.leftClick,
    onClickRight: $options.rightClick
  }, {
    right: _withCtx(() => [$props.hint ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "question-o"
    })) : _renderSlot(_ctx.$slots, "default", {
      key: 1
    })]),
    _: 3
  }, 8, ["title", "left-text", "left-arrow", "onClick", "onClickLeft", "onClickRight"]);
}